<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useAdafStore } from '@organisms/ubiq-administration/store/adaf';
import SimpleTable from '../ubiq-administration/general/SimpleTable.vue';
import SimpleTableMobile from '../ubiq-administration/general/SimpleTableMobile.vue';

const adafStore = useAdafStore();

// @TODO Centralize in pinia store, see https://bureaux-a-partager.atlassian.net/browse/MATCH-9839
const isMobile = ref(false);

const checkIsMobile = () => {
  isMobile.value = window.BREAKPOINTS.isMobile;
};

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
});
</script>

<template>
  <div>
    <SimpleTable
      v-show="!isMobile"
      :data="adafStore.formattedDealPaymentLines"
      :headers="adafStore.headersTable"
      activate-inside-lines
      scroll-into-container="simple-table-wrap"
    />
    <SimpleTableMobile
      v-show="isMobile"
      prefix="ADAF"
      :data="adafStore.dealPaymentsForMobile"
      row-type="action"
      table-with-border
    />
  </div>
</template>
